module.exports = __webpack_public_path__ + "img/profile-mail.29305001.svg";